module.exports = __webpack_public_path__ + "img/9-role-of-collaboration-in-a-business.41ea2e9c.png";